export class FanModel {
    fanId: string;
    status: string;
    participationDate?: string;
    profile: string; // ProfileModel profileId
    selected?: boolean;
}
